import React, { useState} from "react";
import { Card } from "antd";
import { Coins, Gift, Users } from "lucide-react";



const AwardCreditSummaryCard = (props) => {
  const {
  } = props;


  const rewardStatus =
  [  
    {
      id: 1,
      title: "Company Balance",
      icon: Coins,
      count: 4050,
      color: "emerald-white",
    },
    {
      id: 2,
      title: "Credits Awarded (Month)",
      icon: Gift,
      count: 550,
      color: "purple-white",
    },
        {
      id: 3,
      title: "Team Members Rewarded",
      icon: Users,
      count: 2,
      color: "blue-white",
    },

  ];
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {rewardStatus.map((item) => {
        const Icon = item.icon;
        return(
          <Card
          key={item.id}
          className={`rounded-xl card-border-s ${item.color}`}
        >
          <div className="flex items-center justify-between"> 
            <div>
              <p className="text-[12px] text-muted-foreground mb-1">{item.title}</p>
              <p className="text-[24px] font-semibold card-text">{item.count.toLocaleString()}</p>
            </div>
            <div className="icon-theme p-3 rounded-xl">
              <Icon className="w-6 h-6" />
            </div>
          </div>
        </Card>   
        );
      })}
    </div>
  );
};

export default AwardCreditSummaryCard;
